  const mainCont = document.querySelector('main#MainContent'); 
  const btns = document.querySelectorAll('.rdc-toggle-btn');

  const toggleEl = function () {
    const elem = document.querySelector(`[data-id=${this.dataset.for}]`);
    const elemParentChil = elem.parentElement.children;

    Array.from(elemParentChil).forEach((elemParentChild) => {
      elemParentChild.classList.remove('rdc-active');
    });

    Array.from(this.parentElement.children).forEach((thisParentChild) => {
      thisParentChild.classList.remove('rdc-active');
    });

    elem.classList.add('rdc-active');
    this.classList.add('rdc-active');
  };

  btns.forEach((btn) => btn.addEventListener('click', toggleEl));

    //Toggle the menu drawer
  setTimeout(() => {
  const drawerBtns = [document.querySelector('.menu-list__list-item a[href="#"]'),document.querySelector('.yb-menu-cls'),document.querySelector('.menu-drawer-container')];
  const menuDr = document.querySelector('.yb-menu');

  const toggleDr = function (e) {
    e.preventDefault();
    menuDr.classList.toggle('rdc-active');
    mainCont.classList.toggle('rdc-p-fix');
};

  drawerBtns.forEach(drawerBtn => {
    drawerBtn.addEventListener('click',toggleDr);
});
  }, 500);
